<template>
  <!-- 头部 -->
  <Layout>
    <template #header> 对开控制 </template>
    <template #default>
      <div class="row q-col-gutter-x-md full-height">
        <div class="col-5 col-xs-12 col-sm-5 full-height">
          <q-card bordered class="full-height column card-style">
            <q-card-section class="row">
              <ToggleSwitch
                v-model="isSwitchOn"
                color="#4caf50"
                true-value="功能开启"
                false-value="功能关闭"
              >
              </ToggleSwitch>
              <!-- <q-toggle
              v-model="isSwitchOn"
              checked-icon="check"
              color="green"
              unchecked-icon="clear"
              false-value="功能关闭"
              true-value="功能开启"
              size="xl"
            /> -->
            </q-card-section>
            <q-card-section
              class="row justify-center items-center car-img"
              style="flex: 1"
            >
              <div style="font-weight: bold; position: absolute; top: -15px">
                <template v-for="(selection, index) in selections" :key="index">
                  <q-chip
                    size="17px"
                    class="select-chip"
                    :selected="selection.value"
                    :icon-selected="selection.icon"
                    @update:selected="
                      (value: any) => handleSelectionChange(selection.name, value)
                    "
                    :icon="selection.icon"
                    :label="selection.label"
                    :disable="selectionsDisable[selection.name]"
                  >
                  </q-chip>
                </template>
              </div>
              <q-img
                class="car-img"
                :src="底盘透明_纵向_不带轮胎"
                :style="{
                  height: IMG_HEIGHT + 'px',
                  width: IMG_WIDTH + 'px',
                }"
                spinner-color="white"
                fit="contain"
              >
                <!-- 轮胎 -->
                <q-img
                  v-for="(tire, index) in tires"
                  :key="tire.name"
                  :style="{
                    position: 'absolute',
                    left: tire.position.left + 'px',
                    top: tire.position.top + 'px',
                    right: tire.position.right + 'px',
                    bottom: tire.position.bottom + 'px',
                    width: TIRES_WIDTH + 'px',
                    height: TIRES_HEIGHT + 'px',
                    transform: 'rotate(' + -tire.value + 'deg)',
                    // borderRadius: '10px',
                    // transition: 'all 0.1s ease-in-out',
                  }"
                  :src="tire.src"
                  alt="tire"
                >
                  <canvas
                    :ref="(el: any) => setCanvas(el, index)"
                    class="sector-shape"
                    :style="{
                      position: 'absolute',
                      top: getTop(index),
                      left: getLeft(index),
                      display: tire.value == 0 ? 'none' : '',
                    }"
                  ></canvas>
                </q-img>
                <div
                  :style="{
                    position: 'absolute',
                    left: `200px`,
                    top: `0px`,
                    width: '150px',
                    display: 'flex',
                    fontSize: '18px',
                  }"
                >
                  <p class="gradient-text">
                    {{ fanList[1].text }}
                  </p>
                </div>
                <!-- 右后车轮旁边的 div -->
                <div
                  :style="{
                    position: 'absolute',
                    left: `200px`,
                    top: `280px`,
                    width: '150px',
                    display: 'flex',
                    fontSize: '18px',
                  }"
                >
                  <div class="gradient-text">
                    {{ fanList2[1].text }}
                  </div>
                </div>
                <!-- 左前车轮旁边的 div -->
                <div
                  :style="{
                    position: 'absolute',
                    left: `-80px`,
                    top: `60px`,
                    width: '150px',
                    fontWeight: 'bold',
                    fontSize: '18px',
                  }"
                >
                  <Statistic
                    name="FL附着"
                    :value="tires[0].attachment || 0"
                    icon=""
                    :width="130"
                    style="font-size: 14px"
                  ></Statistic>
                </div>
                <div
                  :style="{
                    position: 'absolute',
                    left: `-80px`,
                    top: `340px`,
                    width: '150px',
                    fontWeight: 'bold',
                    fontSize: '18px',
                  }"
                >
                  <Statistic
                    name="RL附着"
                    :value="tires[3].attachment || 0"
                    icon=""
                    :width="130"
                    style="font-size: 14px"
                  ></Statistic>
                </div>
                <div
                  :style="{
                    position: 'absolute',
                    left: `180px`,
                    top: `60px`,
                    width: '150px',
                    fontWeight: 'bold',
                    fontSize: '18px',
                  }"
                >
                  <Statistic
                    name="FR附着"
                    :value="tires[1].attachment || 0"
                    icon=""
                    :width="130"
                    style="font-size: 14px"
                  ></Statistic>
                </div>
                <div
                  :style="{
                    position: 'absolute',
                    left: `190px`,
                    top: `340px`,
                    width: '150px',
                    backgroundColor: 'rgba(255, 255, 255, 0.0)',
                    fontWeight: 'bold',
                    fontSize: '18px',
                  }"
                >
                  <Statistic
                    name="RR附着"
                    :value="tires[2].attachment || 0"
                    icon=""
                    :width="130"
                    style="font-size: 14px"
                  ></Statistic>
                </div>
                <div
                  class="gauge-text"
                  :style="{
                    position: 'absolute',
                    width: '150px',
                    left: `70px`,
                    top: `210px`,
                    backgroundColor: 'rgba(255, 255, 255, 0.0)',
                    fontSize: '18px',
                    display: 'flex',
                  }"
                >
                  <div class="gradient-text">
                    {{ Math.round(UIRx_SBW_HWAAng) }}°
                  </div>
                </div>
              </q-img>
              <!-- <q-btn
                :style="{
                  position: 'absolute',
                  right: '23px',
                  bottom: '23px',
                }"
                :class="playStatus === 'play' ? 'btn-active' : 'btn-style'"
                @click="handlePlayStatusChange"
                size="16px"
                round
                :color="playStatus === 'play' ? 'grey-9' : 'brown-4'"
                text-color="grey-1"
                :icon="playStatus === 'play' ? 'pause' : 'play_arrow'"
              /> -->
            </q-card-section>
          </q-card>
        </div>
        <div class="col-7 col-xs-12 col-sm-7 right-column full-height">
          <q-card
            bordered
            class="column full-height card-style overflow-hidden"
          >
            <div class="column overflow-hidden" style="flex: 1; padding: 5px">
              <div
                class="col-4 overflow-hidden"
                style="
                  flex: 1;
                  border-top-right-radius: 10px;
                  border-top-left-radius: 10px;
                "
              >
                <DomainControlCharts
                  :title="title1"
                  :max="20"
                  :min="-20"
                  :start="15"
                  :end="-15"
                  :xAxisLength="7"
                  :series="optionsF"
                  :showXAxisLabel="false"
                />
              </div>
              <div class="col-4 overflow-hidden">
                <DomainControlCharts
                  :title="title2"
                  :max="540"
                  :min="-540"
                  :start="150"
                  :end="-150"
                  :xAxisLength="7"
                  :series="optionsG"
                  :showXAxisLabel="false"
                />
              </div>
              <div
                class="col-4 overflow-hidden"
                style="
                  flex: 1;
                  border-bottom-right-radius: 10px;
                  border-bottom-left-radius: 10px;
                "
              >
                <DomainControlCharts
                  :max="5"
                  :min="-5"
                  :start="3"
                  :end="-3"
                  :xAxisLength="7"
                  :series="optionsH"
                  :showXAxisLabel="true"
                />
              </div>
            </div>
          </q-card>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { onMounted, ref, nextTick, watch, reactive } from "vue";
import Layout from "./components/Layout.vue";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import { useDomainControlStore } from "@/stores/domainControl";
import {
  decreasingSequence,
  getDefaultSelections,
  getDefaultSeriesData,
  optionseries1,
  optionseries2,
  optionseries3,
  PlayStatus,
} from "./helper/dst";
import {
  generateMockDURNofifyData,
  NOTIFY,
} from "@/services/domainControl/dst";
import DomainControlCharts from "@/components/DomainControlCharts";
import { useQuasar } from "quasar";
import { isWeb } from "@/utils/capacitor";
import 底盘透明_纵向_不带轮胎 from "@/assets/img/底盘透明_纵向_不带轮胎.png";
import 轮胎左 from "@/assets/img/轮胎左.png";
import { signalTransformBool2Num, signalTransformNum2Bool } from "./helper";
import Statistic from "@/views/DomainControl/components/IVSE/Statistic";
import { getTitle3 } from "./helper/dst";
import ToggleSwitch from "@/components/ToggleSwitch";

const $q = useQuasar();
const titleOption3 = getTitle3($q);
const title1 = { text: "横摆角速度", ...titleOption3 };
const title2 = { text: "方向盘转角", ...titleOption3 };
const IMG_HEIGHT = 500;
const CAR_HEIGHT = 1810;
const IMG_RATE = IMG_HEIGHT / CAR_HEIGHT;
const IMG_WIDTH = 813 * IMG_RATE;
const TIRES_TOP = 245 * IMG_RATE;
const TIRES_BOTTOM = 367 * IMG_RATE;
const TIRES_HEIGHT = 250 * IMG_RATE;
const TIRES_WIDTH = 96 * IMG_RATE;
const TIRES_RIGHT = 76 * IMG_RATE;
const TIRES_LEFT = 90 * IMG_RATE;
const UIRx_SBW_HWAAng = ref(0);
const UIRx_VehSpd = ref();
const optionsF = ref(optionseries1());
const optionsG = ref(optionseries1());
const optionsH = ref(optionseries3());
const isSwitchOn = ref("功能开启");
const setOpthonsF = ref();
const setOpthonsG = ref();
const domainControlStore = useDomainControlStore();
const playStatus = ref<PlayStatus>("play");
const selections = ref(getDefaultSelections());
const seriesData = ref(getDefaultSeriesData());
const isInited = ref(false);

const selectionsDisable = {
  UITx_ActuatorEna_SbW: true,
  UITx_ActuatorEna_Rws: false,
} as Dictionary<boolean>;

const notifyData = reactive({} as Partial<DomianControl.DSTNotifyData>);
const tires = ref([
  {
    name: "左前",
    value: 0,
    error: false,
    src: 轮胎左,
    position: { left: TIRES_LEFT, top: TIRES_TOP },
    gaugePosition: { left: -110, top: -50 },
    canvasRef: null,
    attachment: "0.0",
  },
  {
    name: "右前",
    value: 0,
    error: false,
    src: 轮胎左,
    position: { right: TIRES_RIGHT, top: TIRES_TOP },
    gaugePosition: { right: 0, top: -50 },
    canvasRef: null,
    text: "",
    attachment: "0.0",
  },
  {
    name: "右后",
    value: 0,
    error: false,
    src: 轮胎左,
    position: { right: TIRES_LEFT, bottom: TIRES_BOTTOM },
    gaugePosition: { right: 0, bottom: 100 },
    canvasRef: null,
    text: "",
    attachment: "0.0",
  },
  {
    name: "左后",
    value: 0,
    error: false,
    src: 轮胎左,
    position: { left: TIRES_RIGHT, bottom: TIRES_BOTTOM },
    gaugePosition: { left: -110, bottom: 100 },
    canvasRef: null,
    attachment: "0.0",
  },
]);

const canvases = ref([] as HTMLCanvasElement[]);
const fanList = ref([
  { angle: 0, dir: 90, text: "" },
  { angle: 0, dir: 270, text: "0°" },
]);
const fanList2 = ref([
  { angle: 0, dir: 90, text: "" },
  { angle: 0, dir: 270, text: "0°" },
]);

onMounted(() => {
  nextTick(() => {
    tires.value.forEach((tire, index) => {
      const canvas = tire.canvasRef;
      if (canvas) {
        canvases.value[index] = canvas;
        createCanvas(index);
      }
    });
  });
});

function getTop(index: number) {
  const tire = tires.value[index];
  if (tire.name === "右前" || tire.name === "左前") {
    return `-10px`;
  } else {
    return `-10px`;
  }
}

function getLeft(index: number) {
  const tire = tires.value[index];
  if (tire.name === "右后" || tire.name === "左后") {
    return `-35px`;
  } else {
    return `-35px`;
  }
}

function setCanvas(el: any, index: number) {
  canvases.value[index] = el;
  nextTick(() => {
    createCanvas(index);
  });
}

function createCanvas(index: number) {
  const canvas = canvases.value[index];
  if (!canvas) {
    return;
  }
  const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
  if (!ctx) {
    console.error(`无法获取 CanvasRenderingContext2D ${index}`);
    return;
  }
  canvas.width = 130;
  canvas.height = 100;
  ctx.translate(50, 50);
  ctx.lineWidth = 1;
  ctx.fillStyle = "#e0f7fa";
  ctx.strokeStyle = "#e0f7fa";
  ctx.shadowColor = "#e0f7fa";
  ctx.shadowBlur = 10;
  ctx.shadowOffsetX = 3;
  ctx.shadowOffsetY = 1;
  ctx.fillRect(100, 100, 200, 100);
  const tire = tires.value[index];
  if (tire.name === "左前" || tire.name === "右前") {
    createStation(ctx, fanList.value);
  } else if (tire.name === "左后" || tire.name === "右后") {
    createStation(ctx, fanList2.value);
  }
}

function createStation(ctx: CanvasRenderingContext2D, fanList: any[]) {
  fanList.forEach((t) => {
    const dir = ((t.dir - t.angle / 2) * Math.PI) / 180;
    drawFan(ctx, t.angle, dir);
  });
}

function drawFan(ctx: CanvasRenderingContext2D, angle: number, dir: number) {
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.rotate(dir);

  const absAngle = Math.abs(angle);
  if (angle < 0) {
    const value = 360 - absAngle;
    ctx.arc(0, 0, 49, 0, (Math.PI / 180) * value, true); // 反向绘制
  } else {
    ctx.arc(0, 0, 49, 0, (Math.PI / 180) * absAngle, false); // 正向绘制
  }

  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
}

const parseData = async (value: DomianControl.DSTNotifyData) => {
  if (
    notifyData.UIRx_ABSSplitCtrlSts_BCh1 !== undefined &&
    notifyData.UIRx_ABSSplitCtrlSts_BCh1 !== 0
  ) {
    if (value.UIRx_ABSSplitCtrlSts_BCh1 === 0) {
      await handlePlayStatusChange("pause");
    }
  }
  Object.keys(value).forEach((key) => {
    notifyData[key] = value[key];
  });
};
const handleNotify = async (data: DomianControl.DSTNotifyData) => {
  UIRx_SBW_HWAAng.value = data.UIRx_SBW_HWAAng;
  UIRx_VehSpd.value = Math.round(data.UIRx_VehSpd);
  setOpthonsF.value = data.UIRx_FrontGearRto;
  setOpthonsG.value = data.UIRx_RearGearRto;

  tires.value.forEach((tire) => {
    if (tire.name === "左前" || tire.name === "右前") {
      tire.value = data.UIRx_AxleStAng_FA || 0;
      fanList.value.forEach((item) => {
        item.angle = tire.value;
        item.text = `${tire.value}°`;
        tire.attachment = `${
          tire.name === "左前" ? data.UIRx_mueFL : data.UIRx_mueFR
        }`;
      });
    } else {
      tire.value =
        //IVSE、DST: 后轮转向关闭UITx_ActuatorEna_Rws=0时，不实时显示后轮转向UIRx_AxleStAng_RA信号的数值。UI显示0
        domainControlStore.outputValueParsed.UITx_ActuatorEna_Rws === 0
          ? 0
          : data.UIRx_AxleStAng_RA || 0;
      fanList2.value.forEach((item) => {
        item.angle = tire.value;
        item.text = `${tire.value}°`;
        tire.attachment = `${
          tire.name === "左后" ? data.UIRx_mueRL : data.UIRx_mueRR
        }`;
      });
    }
  });

  await parseData(data);
  if (playStatus.value !== "play") return;
  parseSeriesData(data);
};

const getKeys = () => {
  const res = [
    "UIRx_AxleStAng_FA",
    "UIRx_ACUYawRate",
    "UIRx_ABSSplitCtrlSts_BCh1",
    "UIRx_AxleStAng_RA",
  ];

  if (isSwitchOn.value === "功能关闭") {
    return res.concat(["UIRx_ACUYawRate_off", "UIRx_SBW_HWAAng_off"]);
  } else {
    return res.concat(["UIRx_ACUYawRate_open", "UIRx_SBW_HWAAng_open"]);
  }
};

const resetSeriesDataByBtnToggle = () => {
  // 重置 seriesData 使用 perSeriesData
  // const datas = seriesData.value;
  // const res = Object.keys(datas).reduce((pre, key) => {
  //   const value = datas[key];
  //   if (isSwitchOn.value === "功能关闭") {
  //     if (key.includes("_open")) {
  //       pre[key] = value;
  //       return pre;
  //     }
  //   } else {
  //     if (key.includes("_off")) {
  //       pre[key] = value;
  //       return pre;
  //     }
  //   }
  //   pre[key] = [];
  //   return pre;
  // }, {} as any);
  const keys = getKeys();
  keys.map((key) => {
    seriesData.value[key] = [];
  });
  console.log(
    "[BOWEN_LOG] 🚀 ~~ resetSeriesDataByBtnToggle ~~ res:",
    seriesData.value
  );

  // 重置虚线
};

const handlePlayStatusChange = async (type: PlayStatus) => {
  const value = type;
  if (value === "play") {
    // seriesData.value = getDefaultSeriesData();
    resetSeriesDataByBtnToggle();
    if (!isNotifyed.value) {
      $q.loading.show();
      await startNotifications().finally(() => $q.loading.hide());
    }
  }
  playStatus.value = value;
};

watch(
  () => seriesData.value,
  (newValue) => {
    if (!isInited.value) return;
    const {
      UIRx_ACUYawRate,
      UIRx_AxleStAng_FA,
      UIRx_AxleStAng_RA,
      UIRx_ABSSplitCtrlSts_BCh1,
      UIRx_ACUYawRate_open,
      UIRx_ACUYawRate_off,
      UIRx_SBW_HWAAng_open,
      UIRx_SBW_HWAAng_off,
    } = newValue;

    (optionsF.value as any)[0].data = UIRx_ACUYawRate_open;
    (optionsF.value as any)[1].data = UIRx_ACUYawRate_off;
    (optionsG.value as any)[0].data = UIRx_SBW_HWAAng_open;
    (optionsG.value as any)[1].data = UIRx_SBW_HWAAng_off;
    (optionsH.value as any)[0].data = UIRx_AxleStAng_FA;
    (optionsH.value as any)[1].data = UIRx_AxleStAng_RA;
  }
);
const handleSelectionChange = (type: string, value: boolean) => {
  const data = signalTransformBool2Num(value);
  domainControlStore.writeOutputValue({
    [type]: data,
  });
  selections.value.forEach((item) => {
    if (item.name === type) item.value = value;
  });
};
const handleSliderChange = (type: string, value: number) => {
  domainControlStore.writeOutputValue({
    [type]: value,
  });
};

watch(isSwitchOn, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    const value = newValue === "功能开启" ? 1 : 0;
    handleSliderChange("UITx_DST_Ena", value);
    console.log("[BOWEN_LOG] 🚀 ~~ watch ~~ newValue:", newValue);
    handlePlayStatusChange("play");
  }
});

const parseSeriesData = (data: DomianControl.DSTNotifyData) => {
  const res = [
    "UIRx_ACUYawRate_open",
    "UIRx_ACUYawRate_off",
    "UIRx_SBW_HWAAng_open",
    "UIRx_SBW_HWAAng_off",
    "UIRx_AxleStAng_FA",
    "UIRx_ACUYawRate",
    "UIRx_ABSSplitCtrlSts_BCh1",
    "UIRx_AxleStAng_RA",
  ].reduce((per, key) => {
    const rawKey = key.replace(/(_open)|(_off)/, "");

    const value = data[rawKey];
    const curList = seriesData.value[key] || [];

    if (key.includes("_open") && isSwitchOn.value !== "功能开启") {
      per[key] = curList;
      return per;
    }
    if (key.includes("_off") && isSwitchOn.value !== "功能关闭") {
      per[key] = curList;
      return per;
    }
    if (curList.length >= decreasingSequence.length) curList.shift();
    curList.push(value);
    per[key] = curList;
    return per;
  }, {} as DomianControl.DSTSeriesData);
  seriesData.value = res;
};

const parseOutputValue = (value: DomianControl.OutputValue) => {
  const { UITx_DST_Ena } = value;
  isSwitchOn.value = UITx_DST_Ena === 1 ? "功能开启" : "功能关闭";
  domainControlStore.writeOutputValue({
    UITx_ActuatorEna_SbW: 1,
    UITx_ActuatorEna_Rws: 1,
  });
  isInited.value = true;
};
const { startNotifications, stopNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});
// onMounted(() => {
//   setInterval(() => {
//     handleNotify(generateMockDURNofifyData() as any);
//   }, 1000);
// });
</script>

<style scoped lang="scss">
.car-img {
  :deep(.q-img__content) > div {
    background-color: transparent;
    padding: 0;
  }
}
.sector-shape {
  position: absolute;
  z-index: 100;
  text-align: center;
}

.progress-style {
  position: absolute;
  top: 34vh;
  right: 19.5vw;
}

.gauge-text {
  position: absolute;
  top: 43vh;
  right: 19.5vw;
}
.ellipsis {
  color: #000;
}
.q-img {
  overflow: unset;
}

.gauge-style {
  color: white;
  width: 50px;
  height: 50px;
  border: 3px solid aqua;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
}

.card-style {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.input-row {
  padding: 10px;
  text-align: center;
}

.swerve {
  width: 16vw;
  height: 6vh;
  border-radius: 10px;
  background-color: rgba(112, 111, 111, 0.4);
  margin: auto;
  line-height: 6vh;
  font-size: 18px;

  span {
    color: #fff;
  }
}

.swerve2 {
  width: 3vw;
  height: 10vh;
  margin: auto;
  line-height: 10vh;
}

.glowing-effect {
  position: relative;
  top: -15px;
  width: 70%;
  height: 10px; /* 根据需求调整高度 */
  margin: 0 auto;
}

.glowing-effect::before {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgb(255, 255, 255) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* 中间亮，边缘透明 */
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}

.btn-style {
  background: radial-gradient(
    circle at center,
    rgba(252, 251, 251, 0.8) 0%,
    /* 中心发光 */ rgb(176, 183, 193) 40%,
    /* 渐变过渡 */ rgb(142, 150, 161) 100% /* 边缘颜色 */
  ) !important;
}
.btn-active {
  background: radial-gradient(
    circle at center,
    rgba(247, 194, 145, 0.8) 0%,
    /* 中心发光 */ rgb(215, 153, 82) 40%,
    /* 渐变过渡 */ rgb(224, 101, 1) 100% /* 边缘颜色 */
  ) !important;
}
</style>
